import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";


import Card from "../assets/img/vcard.png";

const ViewCard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let card = location.state.card;


    const [showCard, setShowCard] = useState(false);

    // useEffect(() => {
        
    // }, []);


  async function approveCard() {
    const token = localStorage.getItem("token");
    try {
      const res = await api.get(`/admin/approve-card/${card.user_id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        swal("Success!", res.data.message, "success", {
            button: false,
            timer: 1500,
          });
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }

  return (
    <div>
            <Header/>
            <Sidebar/>
            <main id="main" className="main">
              <div className="pagetitle">
                <h1>Cards</h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/cards">Cards</a></li>
                    <li className="breadcrumb-item active">Card</li>
                  </ol>
                </nav>
              </div>{/* End Page Title */}
              
                <section className="section profile">
                    <div className="row">
                    <div className="col-xl-4">
                        <div className="card">
                        <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                            <img src={Card} alt="Card"  />
                            <h2>{showCard ? card.card_pan : card.masked_pan}</h2>
                            <h3>{card.email}</h3>
                            <div className="social-links mt-2">
                            <a href="#"><i className="bi bi-patch-check" /> Active</a>
                            </div>
                        </div>
                        </div>
                        <div class="d-grid gap-2 mt-3">
                            {!showCard ? 
                            <a class="btn btn-primary mb-2" onClick={() => setShowCard(true)}>Show Card Details</a> : 
                            <a class="btn btn-info mb-2" onClick={() => setShowCard(false)}>Hide Card Details</a>}
                            <a class="btn btn-warning mb-2" onClick={() => {}}>Block Card</a>
                            <a class="btn btn-danger mb-2" onClick={() => {}}>Terminate Card</a>
                        </div>

                        <div className="modal fade" id="verification" tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                <h5 className="modal-title">KYC Verification</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                This check costs N50.00 via flutterwave BVN verification API, make sure user provides correct details for proper check.
                                </div>
                                <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" data-bs-dismiss="modal" onClick={()=>approveCard()} className="btn btn-primary">Proceed</button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="card">
                        <div className="card-body pt-3">
                            {/* Bordered Tabs */}
                            <ul className="nav nav-tabs nav-tabs-bordered">
                            <li className="nav-item">
                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#profile-overview">Overview</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#card-balance">Balance</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#card-transactions">Transactions</button>
                            </li>
                            </ul>
                            <div className="tab-content pt-2">
                            <div className="tab-pane fade show active profile-overview" id="profile-overview">
                                <h5 className="card-title">Card Details</h5>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Name on Card</div>
                                <div className="col-lg-9 col-md-8">{card.name_on_card}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Card Number</div>
                                <div className="col-lg-9 col-md-8">{showCard ? card.card_pan : card.masked_pan}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Card Expiry</div>
                                <div className="col-lg-9 col-md-8">{showCard ? card.expiration : "****/**"}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">CVV</div>
                                <div className="col-lg-9 col-md-8">{showCard ? card.cvv : "***"}</div>
                                </div>
                                <h5 className="card-title">Billing Details</h5>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Billing Name</div>
                                <div className="col-lg-9 col-md-8">{card.name_on_card}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Billing Address</div>
                                <div className="col-lg-9 col-md-8">{card.address_1}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">City</div>
                                <div className="col-lg-9 col-md-8">{card.city}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">State</div>
                                <div className="col-lg-9 col-md-8">{card.state}</div>
                                </div>

                            </div>
                            <div className="tab-pane fade show profile-overview" id="card-balance">
                                <h5 className="card-title">Card Balance</h5>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">Currency</div>
                                    <div className="col-lg-9 col-md-8">{card.currency}</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">Balance</div>
                                    <div className="col-lg-9 col-md-8">{card.amount}</div>
                                </div>
                            </div>
                            <div className="tab-pane fade show profile-overview" id="card-transactions">
                                <h5 className="card-title">All Transactions</h5>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Name on Card</div>
                                <div className="col-lg-9 col-md-8">{card.name_on_card}</div>
                                </div>
                            </div>
                            </div>{/* End Bordered Tabs */}
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            </main>{/* End #main */}
           <Footer/>
            <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
          </div>
      );

}


export default ViewCard;